import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'
import { Apps } from 'SRC/ui/FormElements'

export const ViberAndWhatsapp = ({ index }) => {
  const { t } = useTranslation('common')

  const getField = () => ({
    id: `apps-${index}`,
    viberFieldName: `phones[${index}].viber`,
    whatsappFieldName: `phones[${index}].whatsapp`,
    label: t('login_update_form_viberWhatsApp'),
    formName: 'update',
    index: index
  })

  return <Apps {...getField()} />
}

ViberAndWhatsapp.propTypes = {
  index: PropTypes.number.isRequired
}

ViberAndWhatsapp.defaultProps = {
  index: 0
}
